export const MuiTabs = (theme) => {
    const { text } = theme.palette;
    return {
        styleOverrides: {
            root: {
                '& .MuiTabs-indicator': {
                    height: '2px',
                    bottom: '2px'
                },
                '& .MuiTabs-scrollButtons': {
                    color: text.primary,
                    '& .MuiSvgIcon-root': {
                        fontSize: 20
                    }
                },
                '& .MuiTab-root': {
                    padding: 0,
                    textTransform: 'none',
                    fintSize: '15px',
                    fontWeight: 400,
                    lineHeight: '26px',
                    letterSpacing: '0.46px',
                    '&.Mui-selected': {
                        fontWeight: 800
                    },
                    '&.Mui-focusVisible': {
                        outlineOffset: '-2px'
                    }
                }
            }
        }
    };
};
